import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const Auth = () => import(/* webpackChunkName: "group-foo" */ '../view/Auth.vue')
const Login = () => import(/* webpackChunkName: "group-foo" */ '../view/Login.vue')
const HelloWorld = () => import(/* webpackChunkName: "group-foo" */ '../components/HelloWorld.vue')
const Failed = () => import(/* webpackChunkName: "group-foo" */ '../view/Failed.vue')
const QrcodeLogin = () => import(/* webpackChunkName: "group-foo" */ '../view/QrcodeLogin.vue')
const OauthLogin = () => import(/* webpackChunkName: "group-foo" */ '../view/OauthLogin.vue')
const InternalTest = () => import(/* webpackChunkName: "group-foo" */ '../view/InternalTest.vue')
const Feedback = () => import(/* webpackChunkName: "group-foo" */ '../view/Feedback.vue')
const login2 = () => import(/* webpackChunkName: "group-foo" */ '../view/login2.vue')
const IndexNoticeConfig = () => import('../view/IndexNoticeConfig')
const exLoginZh = () => import('../view/ExternalSsoLoginByZh')
const routes = [
  {
    path: '/',
    name: 'Login',
    component: login2
  },
  {
    path: '/login',
    name: 'Login',
    component: login2
  },
  {
    path: '/auth',
    name: 'Auth',
    component: Auth
  },
  {
    path: '/failed',
    name: 'Failed',
    component: Failed
  },
  {
    path: '/qrcodeLogin',
    name: 'QrcodeLogin',
    component: QrcodeLogin
  },
  {
    path: '/oauthLogin',
    name: 'OauthLogin',
    component: OauthLogin
  },
  {
    path: '/InternalTest',
    name: 'InternalTest',
    component: InternalTest
  },
  {
    path: '/Feedback',
    name: 'Feedback',
    component: Feedback
  },{
    path: '/login2',
    name: 'login2',
    component: login2
  },{
    path: '/noticeconfig',
    name: 'IndexNoticeConfig',
    component: IndexNoticeConfig
  },
  {
    path: '/exLoginByZh',
    name: 'exLoginZh',
    component: exLoginZh
  },
]

export default new Router({
  routes: routes,
  mode: 'history',
  base: 'sso_web'
})



// WEBPACK FOOTER //
// ./src/router/index.js